import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { LoginService } from '../../services/login.service';
import { Credentials } from '../../models/credentials.model';
import { MailValidatorService } from 'src/app/shared/services/mail-validator.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    public loginButtonLabel: string = 'Acceder';
    public registerLabel   : string = 'Nuevo usuario';
    public registerUrl     : string = '/registro';
    public forgotLabel     : string = 'Recuperar contraseña';
    public forgotUrl       : string = '/recuperar-password';

    public email   : string;
    public password: string;

    public isValidEmail: boolean;
    public emailValidationError: string;

    public isProcessing: boolean = false;
    public errorMessage: string;

    constructor(private router: Router, private loginService: LoginService, private mailValidatorService: MailValidatorService) { }

    ngOnInit() { }

    public onEmailChange() {

        if (this.email === null && this.email === "") {
            this.email                = null;
            this.isValidEmail         = false;
            this.emailValidationError = null;
            return;
        }

        let emailValidation       = this.mailValidatorService.validate(this.email);
        this.isValidEmail         = emailValidation.success;
        this.emailValidationError = this.isValidEmail ? null : emailValidation.message;

    }

    public isFormValid() : boolean {

        let isValidEmail    = this.email    && this.email    !== null && this.email    !== '' && this.isValidEmail;
        let isValidPassword = this.password && this.password !== null && this.password !== '';

        return isValidEmail && isValidPassword;

    }

    public login() {

        this.isProcessing  = true;
        this.errorMessage = null;

        if (!navigator.onLine) {

            this.errorMessage = 'No hay conexión a internet.';

        } else {

            let userLogin          = new Credentials();
                userLogin.userName = this.email;
                userLogin.password = this.password;

            this.loginService.login(userLogin).subscribe({

                next: () => {
                    this.router.navigate(['/home']);
                },

                error: (error: string) => {
                    this.errorMessage = error;
                }

            })
            .add(() => {
                this.isProcessing = false;
            });

        }

    }

    public resetFormMessages() {

        this.errorMessage = null;

    }

}
